import { notification } from "ant-design-vue";
type notificationType = "success" | "info" | "warning" | "error";
export const showNotification = (
  type: notificationType,
  title: string,
  content = ""
) => {
  notification[type]({
    message: title,
    description: content,
  });
};
